import type { HelpView } from "@tutor/live";
import type { HelpKind } from "@tutor/protocol";
import { useT, type MessageKey } from "../i18n";

// Help buttons under the exercise (ADR-0044). Which ones show is the engine's decision
// (`help.offer`, from the hint ladder); this only draws them. A tap sends Coach a fixed
// sentence, so a child who doesn't type, or doesn't know what to ask, still gets help.

const LABELS: Record<HelpKind, MessageKey> = {
  rephrase: "help.rephrase",
  clue: "help.clue",
  method: "help.method",
  example: "help.example",
};

export function HelpChips(props: {
  help: HelpView | null;
  itemId: string;
  /** The exercise is answered, being checked, or done: no buttons. */
  locked: boolean;
  onHelp: (kind: HelpKind) => void;
}) {
  const t = useT();
  const { help, itemId, locked, onHelp } = props;
  if (locked || help?.itemId !== itemId || help.options.length === 0) return null;
  return (
    <div className="help-chips" role="group" aria-label={t("help.label")}>
      {help.options.map((kind) => (
        <button
          key={kind}
          type="button"
          className="help-chip"
          data-help={kind}
          onClick={() => {
            onHelp(kind);
          }}
        >
          {t(LABELS[kind])}
        </button>
      ))}
    </div>
  );
}
